// extracted by mini-css-extract-plugin
export var checkbox = "_87-0";
export var circle = "_87-3";
export var horizontalContainer = "_87-7";
export var sm = "_87-5";
export var switch0 = "_87-2";
export var switchDisabled = "_87-8";
export var switchEnabled = "_87-1";
export var textSwitchContainer = "_87-9";
export var textSwitchOption = "_87-a";
export var textSwitchOptionSelected = "_87-b";
export var verticalContainer = "_87-6";
export var xs = "_87-4";